import { render, staticRenderFns } from "./FormBuilderMainMenu.vue?vue&type=template&id=096b6354"
import script from "./FormBuilderMainMenu.vue?vue&type=script&lang=js"
export * from "./FormBuilderMainMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports